import React from "react";
import { TestCaseResultComponent } from "./TestCaseResultComponent";
import { CodeValidationResult } from "../../../data/ValidationResult";
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
    root: {
        marginBottom: "10px",
    },
});

interface CodeValidationResultComponentProps {
    validationResult: CodeValidationResult;
}

export function CodeValidationResultComponent(
    props: CodeValidationResultComponentProps
) {
    const { classes } = useStyles();

    return (
        <div className={classes.root}>
            {props.validationResult.testCaseResults.map((elem, index) => (
                <TestCaseResultComponent key={index} element={elem} />
            ))}
        </div>
    );
}
